import React, {Component} from 'react';

import './drag-n-drop-upload.styles.scss';

const UPLOAD_STATUS = {
    DEFAULT: 1,
    BUSY: 2,
    ERROR: 3
};

class DragNDropUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileMessage: 'or drag and drop files here',
      uploadStatus: UPLOAD_STATUS.DEFAULT,
      photos: []
    }
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange (e) {
    const { onChange, onSubmit, autoSubmit } = this.props;
    const filesCount = e.currentTarget.files.length;

    if (filesCount === 1) {
      this.setState({fileMessage: filesCount + ' file selected'});
    } else if (filesCount > 1) {
      this.setState({fileMessage: filesCount + ' files selected'});
    }

    if(filesCount > 0) {
      const {photos} = this.state;
      const newPhotos = photos.concat(Array.from(e.target.files));
      this.setState({photos: newPhotos})
    }

    if (autoSubmit) {
      this.setState({uploadStatus: UPLOAD_STATUS.BUSY});
      onSubmit(e.currentTarget.files);
      this.setState({uploadStatus: UPLOAD_STATUS.DEFAULT, fileMessage: "or drag and drop files here"});
    } else {
      onChange(e.currentTarget.files);
    }
  }

  renderPhotoPreviews() {
    const {photos} = this.state;
    const {showPreviewContainer} = this.props;
    if(photos.length === 0 || !showPreviewContainer) {
      return null;
    }
    return (
      <div className="image-preview-container">
        {photos.map((photo, index) => (
          <div className="preview">
            <i className="far fa-trash-alt" title="Remove" onClick={() => this.removePhoto(index)}></i>
            <img src={URL.createObjectURL(photo)} />
          </div>
        ))}
      </div>
    );
  }

  removePhoto(index) {
    const { photos } = this.state;
    const { removePreview } = this.props;
    photos.splice(index, 1);
    removePreview(index);
    this.setState({photos})
    if (photos.length === 1) {
      this.setState({fileMessage: photos.length + ' file selected'});
    } else {
      this.setState({fileMessage: photos.length + ' files selected'});
    }
  }

  render() {
    const { autoSubmit } = this.props;
    const { uploadStatus, fileMessage } = this.state;
    const photoPreviews = this.renderPhotoPreviews();
    return (
      <div className="form-group image-uploader">
        {!autoSubmit && <label className="translation-section-title text-muted" htmlFor="photos">Photos</label>}
        <div className="file-drop-area">
          <span className="choose-file-button">Choose files</span>
          <span className="file-message">{fileMessage}</span>
          <input type="file" className="file-input" id="photos" multiple onChange={this.handleChange} />
        </div>
        <div className="hint">
          <sup>*</sup> Image max filesize: 10Mb
        </div>
        {photoPreviews}
        {(autoSubmit && uploadStatus !== UPLOAD_STATUS.DEFAULT) &&
          <button className={`btn btn-mondly ${uploadStatus === UPLOAD_STATUS.BUSY ? 'btn-blue' : 'btn-danger'} btn-add-photos`}>
            {uploadStatus === UPLOAD_STATUS.BUSY ? <span className="loading-marker"></span> : 'Try again'}
          </button>
        }
      </div>
    );
  }
}

export default DragNDropUpload;
